import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { EIntegrationPlatform } from "../../models/integrations.model";
import { useIntegrations } from "../../providers/IntegrationsProvider";
import { TConfig } from "../../services/apiWorker";

export const IntegrationF1 = {
  type: EIntegrationPlatform.F1,
  icon: "/assets/integrations/f1.png",
  title: "F1",
  description:
    "Displays live races, results, and exclusive Formula 1 content in your app.",

  openAuth: (config: TConfig) => {
    // const params: { [key: string]: string } = {
    //   client_id: config?.auth.google.clientId || "",
    //   redirect_uri: config?.auth.google.photos.redirectUri || "",
    //   response_type: "code",
    //   scope: config?.auth.google.photos.scopes.join(" ") || "",
    //   include_granted_scopes: "true",
    //   access_type: "offline",
    //   prompt: "consent",
    // };
    // window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${new URLSearchParams(
    //   params
    // ).toString()}`;
  },

  AuthRender: () => {
    const { addIntegration } = useIntegrations();
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
      const scope = searchParams.get("scope");

      // if (scope && scope.includes("www.googleapis.com")) {
      //   const code = searchParams.get("code");
      //   if (code) {
      //     searchParams.delete("code");
      //     searchParams.delete("scope");
      //     searchParams.delete("authuser");
      //     searchParams.delete("prompt");

      //     authGooglePhotos({
      //       accessToken: code,
      //       onSuccess: (data) => {
      //         addIntegration(data);
      //         message.success("Integration done!");
      //       },
      //     });

      //     setSearchParams(searchParams);
      //   }
      // }
    }, [searchParams]);

    return <></>;
  },
};
